module.exports = __webpack_public_path__ + "media/images/articles/work_experience_resume/img01-de681c419574474ad6038adca776313d.png";